import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector, useDispatch } from "react-redux";

import {
  bindLicenseToCustomer,
  unbindLicenseFromCustomer,
} from "../../store/licenses-actions";

const BindHardwareDialog = (props) => {
  const selectedLicense = useSelector(
    (state) => state.licenses.selectedLicense
  );
  const actualHardwareId = selectedLicense.hardwareId;
  const availableHardwares = useSelector(
    (state) => state.hardwares.list
  );

  const identifiers = availableHardwares
    .filter(item => item.isAssigned === false)
    .map(item => item.identifier);

  const [hardwareId, setHardwareId] = useState(actualHardwareId);

  const dispatch = useDispatch();

  const isUnbinding = hardwareId === "" || hardwareId === null;

  const handleOk = async () => {
    if (isUnbinding) {
      dispatch(unbindLicenseFromCustomer(selectedLicense.id, actualHardwareId));
    } else {
      dispatch(bindLicenseToCustomer(selectedLicense.id, hardwareId));
    }
    handleClose();
  };

  const handleClose = () => props.onClose();

  const hardwareIdChangeHandler = (_, newValue) => setHardwareId(newValue);

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="confirmation-dialog-title"
      open={props.open}
    >
      <DialogTitle id="confirmation-dialog-title">License binding</DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description">
          Please eneter a hardware identification serial or pick one form the list below if available.
        </DialogContentText>
        <Autocomplete
          options={identifiers}
          id="hardware-serial-select"
          value={hardwareId}
          freeSolo
          onChange={hardwareIdChangeHandler}
          onInputChange={hardwareIdChangeHandler}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Hardware identifier"
              margin="normal"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default BindHardwareDialog;
